import { Accordion } from '@chakra-ui/react';
import { useAccordionControl } from '../../../../../hooks';
import { IDealRoomSettingSchema } from '@monetize/types/app';
import { MVStack } from '../../../../../components/Monetize';
import { MSettingAccordionItem } from '../../../../../components/Monetize/MSettingAccordionItem';
import { useAsyncStatus } from '../../../../../hooks/useAsyncStatus';
import { SettingsSection } from '../../../components/SettingsSection';
import { SettingsToggle } from '../../../components/SettingsToggle';

interface DealRoomSettingSignerProps {
  dealroomConfig: IDealRoomSettingSchema;
  onSubmit: (payload: IDealRoomSettingSchema) => Promise<void>;
  isDisabled: boolean;
}

export const DealRoomSettingSigner = ({
  dealroomConfig,
  onSubmit,
  isDisabled,
}: DealRoomSettingSignerProps) => {
  const { accordionValue, handleAccordionChange } = useAccordionControl();
  const { status: canChangeStatus, track: trackCanChange } = useAsyncStatus();
  const { status: canCreateStatus, track: trackCanCreate } = useAsyncStatus();

  return (
    <Accordion.Root
      multiple
      w="full"
      value={accordionValue}
      onValueChange={({ value }) => handleAccordionChange(value)}
    >
      <MSettingAccordionItem value="0" label="Signers">
        <MVStack alignItems="start" my={6} gap={4}>
          <SettingsSection showDivider={false}>
            <SettingsToggle
              name="allowEndCustomerChangeSigningContact"
              heading="Allow end customers to change signing contact"
              subheading="If end customers can change the designated signer, it will automatically update the end contract before it is signed."
              fetchLoading={false}
              value={
                dealroomConfig.canEndCustomerChangeSigningContact.canChange
              }
              asyncStatus={canChangeStatus}
              onChange={(val) =>
                trackCanChange(() =>
                  onSubmit({
                    ...dealroomConfig,
                    canEndCustomerChangeSigningContact: {
                      canCreate:
                        dealroomConfig.canEndCustomerChangeSigningContact
                          .canCreate,
                      canChange: val,
                    },
                  }),
                )
              }
              isDisabled={isDisabled}
            />
          </SettingsSection>
          <SettingsSection showDivider={false}>
            <SettingsToggle
              name="allowEndCustomerCreateNewSigningContact"
              heading="Allow end customers to create new signing contacts"
              subheading="If a new contact is created, it will be stored in your MonetizeNow Contact List."
              fetchLoading={false}
              value={
                dealroomConfig.canEndCustomerChangeSigningContact.canCreate
              }
              asyncStatus={canCreateStatus}
              onChange={(val) =>
                trackCanCreate(() =>
                  onSubmit({
                    ...dealroomConfig,
                    canEndCustomerChangeSigningContact: {
                      canCreate: val,
                      canChange:
                        dealroomConfig.canEndCustomerChangeSigningContact
                          .canChange,
                    },
                  }),
                )
              }
              isDisabled={isDisabled}
            />
          </SettingsSection>
        </MVStack>
      </MSettingAccordionItem>
    </Accordion.Root>
  );
};
